<template>
  <div class="product-wrapper col-sm-6 col-lg-2">
    <div
      :class="{ active: isActive }"
      class="product cover"
      :style="{
        'background-image': 'url(' + scent.image.format.small.url + ')',
      }"
    >
      <span class="product-label">{{ scent.title }}</span>
      <div class="action-wrapper">
        <button class="btn-count btn-clean" @click="removeFromCart(scent.id)">
          -
        </button>
        <span class="product-count">{{ amount }}</span>
        <button
          class="btn-count btn-clean"
          :class="{ 'cannot-submit': !maxAllowed }"
          @click="addToCart(scent.id)"
        >
          +
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Product',
  props: {
    scentId: {
      type: Number,
      required: true,
    },
    cartIds: {
      type: Array,
      required: false,
    },
    allowed: {
      type: Number,
      required: true,
    },
  },
  computed: {
    amount() {
      return this.cartIds.filter((id) => {
        return id === this.scentId;
      }).length;
    },
    maxAllowed() {
      return this.cartIds.length < this.allowed;
    },
    isActive() {
      return this.cartIds.includes(this.scentId);
    },
    scent() {
      return this.getScent(this.scentId)[0];
    },
    ...mapGetters({
      getScent: ['scents/getScent'],
    }),
  },
  methods: {
    addToCart(value) {
      if (this.maxAllowed) {
        this.$emit('add-to-cart', value);
      }
    },
    removeFromCart(value) {
      this.$emit('remove-from-cart', value);
    },
  },
};
</script>

<style scoped lang="scss">
.product-wrapper {
  position: relative;
  padding: 0 10px 20px;
  &:before {
    position: absolute;
    content: '';
    height: 100%;
    width: 100%;
    z-index: 98;
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.5));
  }
}

.cover {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.product {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  min-height: 160px;

  border-radius: $border-radius;
  color: $white;

  &:hover,
  &:focus {
    text-decoration: none;
    color: currentColor;
  }

  &.active {
    box-shadow: inset 0 0 0 2px $primary-color;
  }
}

.action-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin: 25px 0 5px;
  width: 100%;
  position: relative;
  z-index: 99;
}

.product-count {
  font-size: 28px;
}

.product-label {
  text-align: center;
  pointer-events: none;
  text-shadow: 1px 1px 1px $black;
  z-index: 100;
}

.product-teaser {
  height: 100px;
  width: 100px;
  border-radius: $border-radius;
}

.btn-count {
  padding: 3px 5px;
  font-size: 32px;
  font-weight: bold;

  &.cannot-submit {
    color: $error;
    cursor: not-allowed;
  }
}
</style>
